import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { StatusBanner } from 'components/shared';
import { NakedButton, Text } from '@weave/design-system';
import { ReactComponent as StatusSuccessIcon } from 'images/status-success.svg';

interface SuccessStatusBannerProps {
  successMessage?: string;
  onTakeNotes: () => void;
}

export const SuccessStatusBanner = ({
  successMessage,
  onTakeNotes,
}: SuccessStatusBannerProps) => {
  return (
    <StatusBanner
      variant="success"
      icon={<StatusSuccessIcon />}
      title="All Checks Passed!"
      description={
        successMessage || 'Looks like all AI Receptionist checks are good to go.'
      }
      action={
        <NakedButton type="button" css={ctaButton} onClick={onTakeNotes}>
          <Text as="span" weight="bold" size="medium">
            Take Notes
          </Text>
        </NakedButton>
      }
    />
  );
};

const ctaButton = css`
  font-weight: ${theme.font.weight.bold};
  padding: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  > span {
    color: #146ef5;
  }
`;
